export const SET_LOADING_STATE = 'SET_LOADING_STATE'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'